// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__tVBeq","main":"index_main__6Z4ah","collapseContent":"index_collapseContent__KA2SJ"};